export default {
  showOutput($optionsContainer, value){
    const $currentOutput = $optionsContainer.querySelector(':scope > [data-value]:not(.is-hidden)');
    const $output = $optionsContainer.querySelector(`:scope > [data-value="${value}"]`);
    if($currentOutput){
      $currentOutput.classList.add('is-hidden');
    }
    if($output){
      $output.classList.remove('is-hidden');
    }
  },

  init(){
    document.querySelectorAll('[data-option-outputs-for]').forEach($optionOutput => {
      const selector = $optionOutput.getAttribute('data-option-outputs-for');
      const $relatedSelect = document.querySelector(selector);
      if($relatedSelect){
        $relatedSelect.addEventListener('change', (evt) => {
          this.showOutput($optionOutput, evt.target.value);
        });
      }
    });
  }
};

